import { useEffect } from "react";
import Slideshow from "./Slideshow";
import ReactPlayer from 'react-player';
import { useMediaQuery } from "react-responsive";

export default function Home() {
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
const isTablet = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1023px)' });
// New category for smaller screens/landscape tablets
const isSmallDesktop = useMediaQuery({ query: '(min-width: 1024px) and (max-width: 1280px)' });

    const cardStyle = {
        backgroundColor: '#fff',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
        width: '100%',
        maxWidth: isMobile ? '100%' : isTablet? '310px' : isSmallDesktop ? '240px' : '440px', // Wichtig für Hochformat
        transition: 'transform 0.3s ease',
        maxHeight: isMobile ? 'none' : '800px'
    };

    useEffect(() => {
    // 1. Find all video elements on the page
    const videoElements = document.querySelectorAll('video');
    
    // 2. Loop through them and apply the attribute
    videoElements.forEach(video => {
      video.setAttribute('controlsList', 'nodownload');
      // Bonus: disable right-click as well
      video.oncontextmenu = (e) => e.preventDefault();
    });
  }, []); // Empty dependency array means this runs once when the page loads

    return (
        <>
            <Slideshow />
            <section className='Projektmanagement'>
                <div className='PicProjektmanagement' />
                <div className='PfeilProjektmanagement' />
                <div className='BoxProjektmanagement' id="Projektmanagement">
                    <span className='BigNumber1_3'>1</span>
                    <span className='Raute1_3'> # </span>
                </div>
                <div className='TextProjektmanagement'>
                    Projektmanagement
                    <span className='TextPosition'>
                        Wir sind ein erfahrener Projektsteuerer und Baumanager, der komplexe Immobilien- und Bauvorhaben erfolgreich und termingerecht abschließt.
                        Unsere bewährte Vorgehensweise beinhaltet eine strukturierte Dokumenten- und Informationsverwaltung, eine integrierte Projektkommunikation,
                        lückenlose Protokollierung und zentrale Dokumentation aller Aktivitäten sowie effizientes Baucontrolling. Durch diese Maßnahmen erreichen
                        wir eine hohe Transparenz und Entscheidungsqualität.
                    </span>
                </div>
            </section>
            <section className='Projektentwicklung'>
                <div className='PicProjektentwicklung' />
                <div className='PfeilProjektentwicklung' />
                <div className='BoxProjektentwicklung' id="Projektentwicklung">
                    <span className='BigNumber2_4'>2</span>
                    <span className='Raute2_4'> # </span>
                </div>
                <div className='TextProjektentwicklung'>
                    Projektentwicklung
                    <span className='TextPosition'>
                        Wir entwickeln Ideen für Ihre Grundstücke und Bauvorhaben, die sich an den möglichen Markt- und Nutzungsverhältnissen orientieren -
                        unabhängig davon, ob es sich um brachliegende Bahn- oder Industrieareale oder städtische Quartiere handelt.
                        Anschließend erarbeiten wir eine marktgerechte Standortentwicklung und unterstützen bei der Investorenansprache.
                        Wir stimmen die ausgearbeiteten Konzepte mit den Zielen und Vorgaben der Interessenten ab und realisieren das erforderliche Baurecht für Sie.
                    </span>
                </div>
            </section>
            <section className='Bauüberwachung'>
                <div className='PicBauüberwachung' />
                <div className='PfeilBauüberwachung' />
                <div className='BoxBauüberwachung' id="Baubetreuung">
                    <span className='BigNumber1_3'>3</span>
                    <span className='Raute1_3'> # </span>
                </div>
                <div className='TextBauüberwachung'>
                    Bauüberwachung
                    <span className='TextPosition'>
                        Wir unterstützen Sie bei Ihrem Bau- oder Sanierungsvorhaben von der Planung bis zur Abnahme des Objekts mit einem 5-Phasen-Check.
                        Unsere Stichproben-Prüfungen spüren Mängel auf, um eine hohe Bauqualität zu sichern und Kosten durch sofortiges Beseitigen zu vermeiden.
                        Wir dokumentieren einheitlich während jeder Bauphase und verwenden dabei neueste Technik. Vertrauen Sie auf unsere langjährige Erfahrung
                        und die Sicherung Ihres Bauvorhabens durch ein geprüftes Nachunternehmensverfahren.
                    </span>
                </div>
            </section>
            <section className='Controlling'>
                <div className='PicControlling' />
                <div className='PfeilControlling' />
                <div className='BoxControlling' id="Controlling">
                    <span className='BigNumber2_4'>4</span>
                    <span className='Raute2_4'> # </span>
                </div>
                <div className='TextControlling'>
                    Controlling Plus<sup style={{ color: "#e94e1b" }}>+</sup>
                    <span className='TextPosition'>
                        Wir bieten professionelle Unterstützung beim Controlling von Terminen und Kosten für Ihr Bauvorhaben. Mit dem Controlling PLUS erstellen
                        wir Kontrollberichte des tatsächlichen Verlaufs im Vergleich zu den Vorgaben der Projektleitung und übernehmen die Bauüberwachung vor Ort
                        für Sie. So begleiten Sie als Bauherr das Projekt intensiv in der Leitungsfunktion.
                    </span>
                </div>
            </section>
            <section className='Videos'>
                <div className='PicVideos' />
                <div className='PfeilBauüberwachung' />
                <div className='BoxBauüberwachung' id="Videos">
                    <div className='VideoIcon' />
                     <span className='Raute1_3'>Videos </span> 
                </div>
                <div className='VideoGrid'>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '20px',
                        justifyItems: 'center'
                    }}>

                        <div style={cardStyle}>
                            <div style={{
                                position: 'relative',
                                paddingTop: '177.78%', // Das perfekte 9:16 Verhältnis für Hochformat
                                backgroundColor: '#000'
                            }}>
                                <ReactPlayer
                                    src="/Bauen Netto Slow.mp4"
                                    width="100%"
                                    height="100%"
                                    controls
                                    style={{ position: 'absolute', top: 0, left: 0 }}
                                />
                            </div>
                            <div style={{ padding: '20px 15px', textAlign: 'left' }}>
                                <h3 style={{ fontSize: '1.1rem', margin: '0', lineHeight: '1.5' }}>Baufortschritt Netto Schweiklberg Slow</h3>
                            </div>
                        </div>

                        <div style={cardStyle}>
                            <div style={{
                                position: 'relative',
                                paddingTop: '177.78%', // Das perfekte 9:16 Verhältnis für Hochformat
                                backgroundColor: '#000'
                            }}>
                                <ReactPlayer
                                    src="/Bauen SpeedRamp.mp4"
                                    width="100%"
                                    height="100%"
                                    controls
                                    style={{ position: 'absolute', top: 0, left: 0 }}
                                />
                            </div>
                            <div style={{ padding: '20px 15px', textAlign: 'left' }}>
                                <h3 style={{ fontSize: '1.1rem', margin: '0', lineHeight: '1.5' }}>Baufortschritt Netto Schweiklberg Speed</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className='Kontakt'>
                <div className='Planbild' />
                <div className='BoxKontakt' id="Kontakt">
                    <div className='KontaktIcon' />
                </div>
                <div className='MapBild' />
                <div className='KontaktText'>
                    <span className='InnerKontaktHeader'>Kontakt</span>
                    <span className='InnerKontaktText'>
                        <span className='Kontakt1'>ha consult<br /></span>
                        <span className='Kontakt2'>Helmut Antesberger <br />
                            Domplatz 2 <br />
                            94032 Passau <br /><br />
                            Telefon: +49 (0)851 379 341 70 <br />
                            Mail: </span>
                        <span className='Kontakt3'><a href="mailto:office@ha-consult.de">office@ha-consult.de</a> <br /><br />
                            <a href="https://www.google.com/maps/place/Domplatz+2,+94032+Passau/@48.5739826,13.4619684,17z/data=!3m1!4b1!4m6!3m5!1s0x477458aa05591795:0xe4eca3c3b564d9b1!8m2!3d48.5739791!4d13.4645433!16s%2Fg%2F11c1_l3_wm?entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D" target='_blank' rel="noopener noreferrer">Routenplanung</a></span>
                    </span>
                </div>
            </section>
        </>
    )
}